// extracted by mini-css-extract-plugin
export default {"container":"zp-z","ratingLayout":"Ap-z","ratingLabel":"Bp-z","nonInteractiveRatingLabel":"Cp-z"};